import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var Spacing = /*#__PURE__*/function () {
  // eslint-disable-next-line no-useless-constructor, no-empty-function
  function Spacing(px) {
    _classCallCheck(this, Spacing);

    this.px = px;
  }

  _createClass(Spacing, [{
    key: "toString",
    value: function toString() {
      return this.px;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return parseFloat(this.px);
    }
  }], [{
    key: "fromPixels",
    value: function fromPixels(px) {
      return new Spacing("".concat(px, "px"));
    }
  }]);

  return Spacing;
}();
export var spacing = {
  xxs: Spacing.fromPixels(4),
  xs2: Spacing.fromPixels(4),
  xs: Spacing.fromPixels(8),
  sm: Spacing.fromPixels(12),
  md: Spacing.fromPixels(16),
  lg: Spacing.fromPixels(24),
  xl: Spacing.fromPixels(36),
  xl2: Spacing.fromPixels(48),
  xl3: Spacing.fromPixels(64),
  xl4: Spacing.fromPixels(96),
  xl5: Spacing.fromPixels(128)
};